<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19m90gI/tc-custom/9781429998314.jpg?1732052883422" alt="This image is the cover for the book This Is How It Goes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">This Is How It Goes
      </h1>
      <p class="bookDescription body article font2">
        <p>Belinda and Cody Phipps <i>appear</i> a typical Midwestern couple: teenage sweethearts, children, luxurious home. Typical except that Cody is black--"rich, black, and different," in the words of Belinda, who finds herself attracted to a former (white) classmate. As the battle for her affections is waged, Belinda and Cody frankly doubt the foundation of their initial attraction, opening the door wide to a swath of bigotry and betrayal. Staged on continually shifting moral ground that challenges our received notions about gender, ethnicity, and even love itself, <i>This Is How It Goes</i> unblinkingly explores the myriad ways in which the wild card of race is played by both black and white in America.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Neil LaBute
      </h2>
      
      <p class="authorDescription body article"><P><B>Neil LaBute</B> is a playwright, filmmaker, and fiction writer. His most recent work for the stage is <I>The Distance from Here, </I>which premiered Off Broadway in 2004.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b7ad237a